import React, {useRef} from "react";
import PropTypes from "prop-types";
import useWindowDimensions from "../../../../hook/useWindowDimension";
import blog from "../../assets/img/blog.svg";
import "./style-mobile.scss";
import AccountModal from "../../../../containers/Modals/AccountModal";
import Banniere from "../../../Banniere/Banniere";

const Account = ({
                     setSelectedItem,
                     logout,
                     setShowAccountModal,
                     showAccountModal,
                     dataUser,
                     navItem
                 }) => {

    const handleShowModalAccount = () => {
// Affiche la modal pour changer les informations du compte
// Cette modal se trouve dans le composant Home et son affichage est donc conditionné par la valeur de showAccountModal
        setShowAccountModal(!showAccountModal);
    };
    const {width} = useWindowDimensions();
    const scrollUpRef = useRef(null);
    return (
        <div className={"pepiteInfos account"}>
            <div className={"pepiteInfos-header pepiteInfos-blog-header account-header"}>
                {width > 599 && <Banniere dataUser={dataUser} navItem={navItem}/>}
                <img src={blog}/>
                <h2 className={"titleMobile1"}>
                    Mon<span className={"titleMobile2 nauticus"}> compte</span>
                </h2>
            </div>
            <div className={"pepiteInfos-container account-container"}>
                {!showAccountModal ?
                    <ul className={"mobile-list-container"}>
                        <li>
                            <div className="container-information" onClick={handleShowModalAccount}>
                                <h4>Vos informations</h4>
                                <p>Modifiez vos informations personnelles.</p>
                            </div>
                        </li>
                        <li
                            onClick={() => {
// Si la la WebView est détecté, on envoi un message à l'application
// Avec ce message, on communique la redirection vers la page d'accueil de l'application
                                if (window["ReactNativeWebView"]) {
                                    window.ReactNativeWebView.postMessage("disconnect");
                                } else {
                                    logout();
                                }
                            }}
                        >
                            <div className="container-disconnect">
                                <h4 className="disconnect">Déconnexion</h4>
                                <p className="disconnect">Déconnectez-vous en toute sécurité.</p>
                            </div>
                        </li>
                    </ul>
                    : <div className={"mobile-list-container"}>
                        <AccountModal scrollUpRef={scrollUpRef}/>
                    </div>
                }
            </div>
        </div>

    );
};

Account.propTypes = {
    setSelectedItem: PropTypes.func,
    logout: PropTypes.func,
    showAccountModal: PropTypes.bool,
    setShowAccountModal: PropTypes.func,
    dataUser: PropTypes.object,
    navItem: PropTypes.string
};

export default Account;
